import {createActionWithoutPayload, createActionWithPayload} from "./utils.actions";
import {InitFontoSession} from "../../types/fonto";


export const [initFontoSessionSuccess, isInitFontoSessionSuccessAction] = createActionWithPayload<InitFontoSession>('INIT_FONTO_SESSION_SUCCESS')
export const [initFontoSessionError, isInitFontoSessionErrorAction] = createActionWithoutPayload('INIT_FONTO_SESSION_ERROR')
export const [initFontoSession, isInitFontoSessionAction] = createActionWithoutPayload('INIT_FONTO_SESSION');
